'use es6';

import { SEQUENCE_TYPE_ID } from '../../../data/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import SequencesReferenceResolver from 'reference-resolvers/resolvers/SequencesReferenceResolver';
const Sequence = ObjectDefinitionRecord({
  enableAsAssociatedType: false,
  objectTypeId: SEQUENCE_TYPE_ID,
  getPropertyResolver: () => SequencesReferenceResolver,
  referenceObjectType: 'SEQUENCE_PROPERTIES'
});
export default Sequence;